/**
 * Whether an MCP client may add candidates to jobs (`finlay:write`).
 * Connections approved before that scope existed hold `finlay:read` only.
 */
export const canAddCandidates = (scopes: string[]) =>
  scopes.includes('finlay:write');

/** How much an MCP client may do, from the OAuth scopes it holds. */
export const accessLabel = (scopes: string[]) =>
  canAddCandidates(scopes) ? 'View and add candidates' : 'View';
